import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("al_token", data.token);
      toast.success(`Welcome back, ${data.user.name}`);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit}
        className="w-full max-w-sm bg-white border border-[#C5A059]/30 p-10 shadow-[0_8px_32px_rgba(0,0,0,0.05)]">
        <div className="flex flex-col items-center mb-10">
          <img src="/assets/logo.png" alt="Australian Luxe" className="w-16 h-16 rounded-full mb-5" />
          <h1 className="font-serif text-2xl font-light tracking-tight">Australian Luxe</h1>
          <p className="text-[10px] tracking-[0.35em] uppercase text-[#9E7B3A] mt-2">Admin Panel</p>
        </div>
        <div className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="admin-email" className="text-xs tracking-widest uppercase text-[#4A4A4A]">Email</Label>
            <Input id="admin-email" type="email" required data-testid="admin-email-input"
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="rounded-none border-[#C5A059]/40 focus-visible:ring-[#C5A059]" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-password" className="text-xs tracking-widest uppercase text-[#4A4A4A]">Password</Label>
            <Input id="admin-password" type="password" required data-testid="admin-password-input"
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="rounded-none border-[#C5A059]/40 focus-visible:ring-[#C5A059]" />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full bg-[#1A1A1A] text-white text-xs tracking-[0.3em] uppercase py-3.5 hover:bg-[#9E7B3A] disabled:opacity-50 transition-colors duration-300">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </div>
      </form>
    </div>
  );
}
